module.exports = __webpack_public_path__ + "img/sjzt-title-bg.4932ca74.svg";